import React from 'react';
import { Table, Button, DropdownButton, MenuItem } from 'react-bootstrap';
import { getUser } from '../../utils/Common';
import { getReadableAccessLevel, getAccessLevelClass } from '../access-control/utils';

export default function CameraAccessTable({
  caps,
  userCaps,
  user,
  handleAccessChange,
  handleNotificationChange,
  renderLastAccess,
  isMobile,
  history
}) {
  return (
    <Table bordered condensed hover className="cap-access-table user-camera-access-table">
      <thead>
        {isMobile && (
          <tr>
            <th />
            <th colSpan="2" style={{ textAlign: 'center' }}>Access</th>
            <th colSpan="2" style={{ textAlign: 'center' }}>Power Notifications</th>
          </tr>
        )}
        <tr>
          <th>Camera</th>
          <th>{isMobile ? 'Tier' : 'Access Tier'}</th>
          <th>{isMobile ? 'Login' : 'Last Accessed'}</th>
          <th className="user-camera-access-notify-col">{isMobile ? 'Email' : 'Power Emails'}</th>
          <th className="user-camera-access-notify-col">{isMobile ? 'App' : 'Power App Notifications'}</th>
        </tr>
      </thead>
      <tbody>
        {caps.map(cap => {
          const userCap = userCaps.find(
            uc => uc.userId === user.userId && uc.capId === cap.capId
          );
          const accessLevel = userCap ? userCap.accessType : 'No Access';
          const tierClass = getAccessLevelClass(accessLevel, user);

          return (
            <tr key={cap.capId}>
              <td className="cap-name-cell">
                <Button
                  bsStyle="default"
                  onClick={() => history.push(`/caps/${cap.capId}`)}
                  className="cap-name-button access-control-cap-link"
                  disabled={cap.status !== 'ACTIVE'}
                  bsSize={isMobile ? 'xs' : 'small'}
                >
                  {cap.name}
                </Button>
              </td>
              <td className={`cap-access-cell ${tierClass}`}>
                <DropdownButton
                  title={getReadableAccessLevel(accessLevel, user, isMobile)}
                  id={`dropdown-${user.userId}-${cap.capId}`}
                  className={`access-tier-dropdown ${tierClass}`}
                  onSelect={(newType) => handleAccessChange(user.userId, cap.capId, newType)}
                  disabled={user.builderStatus === 'ADMIN' || cap.status !== 'ACTIVE'}
                  bsSize={isMobile ? 'xs' : 'small'}
                >
                  <MenuItem eventKey="No Access" className="access-tier--none">
                    {getReadableAccessLevel('No Access', user, isMobile)}
                  </MenuItem>
                  <MenuItem eventKey="DEMO" className="access-tier--demo">
                    {getReadableAccessLevel('DEMO', user, isMobile)}
                  </MenuItem>
                  <MenuItem eventKey="VIEWER" className="access-tier--viewer">
                    {getReadableAccessLevel('VIEWER', user, isMobile)}
                  </MenuItem>
                  <MenuItem eventKey="OWNER" className="access-tier--owner">
                    {getReadableAccessLevel('OWNER', user, isMobile)}
                  </MenuItem>
                  {getUser().role === 'ADMIN' && (
                    <MenuItem eventKey="SALES_DEMO" className="access-tier--sales-demo">
                      {getReadableAccessLevel('SALES_DEMO', user, isMobile)}
                    </MenuItem>
                  )}
                </DropdownButton>
              </td>
              <td className="user-camera-access-time">{renderLastAccess(cap.capId)}</td>
              <td>
                <div className="elegant-checkbox-container">
                  <label className="elegant-checkbox">
                    <input
                      type="checkbox"
                      checked={userCap?.powerNotifications ?? false}
                      onChange={(e) => handleNotificationChange(user.userId, cap.capId, 'powerNotifications', e.target.checked)}
                      disabled={!userCap || userCap.accessType === 'No Access'}
                    />
                    <span className="elegant-checkbox-slider" />
                  </label>
                </div>
              </td>
              <td>
                <div className="elegant-checkbox-container">
                  <label className="elegant-checkbox">
                    <input
                      type="checkbox"
                      checked={userCap?.appNotifications ?? false}
                      onChange={(e) => handleNotificationChange(user.userId, cap.capId, 'appNotifications', e.target.checked)}
                      disabled={!userCap || userCap.accessType === 'No Access'}
                    />
                    <span className="elegant-checkbox-slider" />
                  </label>
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}
